export default __webpack_public_path__ + "static/media/priority_high.9d13a4d0.svg";